module.exports = __webpack_public_path__ + "static/img/ad-2.43d5c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-2.png
// module id = IBbu
// module chunks = 0